import React, { Component } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix pour l'icône du marqueur (bug connu de Leaflet avec Webpack)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const mapStyles = {
  width: '100%',
  height: '100%'
};

export class MapContainerCabinet extends Component {
  render() {
    const position = [48.9407098, 2.3312907];

    return (
      <div className="test">
        <MapContainer
          center={position}
          zoom={15}
          style={mapStyles}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <Marker position={position}>
            <Popup>
              <h4>Cabinet</h4>
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    );
  }
}

export default MapContainerCabinet;